import { render, staticRenderFns } from "./table-actions.vue?vue&type=template&id=a8dadc50&scoped=true&"
import script from "./table-actions.vue?vue&type=script&lang=js&"
export * from "./table-actions.vue?vue&type=script&lang=js&"
import style0 from "./table-actions.vue?vue&type=style&index=0&id=a8dadc50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dadc50",
  null
  
)

export default component.exports